/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetOrganizationLabelSettingResponseDataFromJSON, GetOrganizationLabelSettingResponseDataToJSON } from './GetOrganizationLabelSettingResponseData';
export function GetOrganizationLabelSettingResponseFromJSON(json) {
    return GetOrganizationLabelSettingResponseFromJSONTyped(json, false);
}
export function GetOrganizationLabelSettingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetOrganizationLabelSettingResponseDataFromJSON(json['data'])
    };
}
export function GetOrganizationLabelSettingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetOrganizationLabelSettingResponseDataToJSON(value.data)
    };
}
